<script>
	import { SportSelectionStatus } from '@/Constants/SportSelection.js';
	import { Status as MarketStatus } from '@/Constants/Market.js';
	import OverridePrice from '@/Partials/Sport/Markets/_OverridePrice.svelte';
	import OverrideLines from '@/Partials/Sport/Markets/_OverrideLine.svelte';
	import { NumberFormat } from '@/Services/Helpers.js';

	export let selection;
	export let market;
	export let price;
	export let liability;
	export let isEditingLines;
	export let isEditingPrices;
	export let isEditingManualPrices;
	export let saveOverridePrices;
	export let saveOverrideLines;
	export let getSelectionStatusClass;
	export let tabIndexValue;

	function selectionIsSuspended(market, selection) {
		return (
			(market.status.id === MarketStatus.Suspended && !market.is_manual) ||
			!selection.tradable ||
			(selection.price === 100 && !market.is_manual) ||
			price === 100
		);
	}

	function selectionIsVoid(selection) {
		return !selection.price || selection.price === 0;
	}

	function selectionIsResulted(selection) {
		return [SportSelectionStatus.Win, SportSelectionStatus.Lost, SportSelectionStatus.Void].includes(
			selection.status.id
		);
	}

	const isMarketResulted = (market) => market && market.status.id === MarketStatus.Resulted;

	function formatLiability(liability) {
		if (!liability) return '-';
		return NumberFormat(liability, true) + '%';
	}

	const doSaveOverridePrices = () => {
		saveOverridePrices(market);
	};
	const doSaveOverrideLines = () => {
		saveOverrideLines(market);
	};
	const getMarketLabel = () => {
		return selection.name + ' - [' + market.type.name + ']' + (market.is_manual ? ' - MANUAL MARKET' : '');
	};
</script>

<td
	class="w-[135px] max-w-[135px] min-w-[135px] {getSelectionStatusClass(selection.id)}"
	class:bg-orange-200={market.is_manual}
	title={getMarketLabel()}
>
	<div class="flex flex-row justify-center items-center space-x-0.5">
		{#if selectionIsSuspended(market, selection) && !market.is_manual}
			SUS <span class="ml-1">[{price}]</span>
		{:else if selectionIsVoid(selection)}
			VOID
		{:else if !isMarketResulted(market) && !selectionIsResulted(selection)}
			{#if market.rolling_type || market.line}
				<OverrideLines
					bind:selectionId={selection.id}
					bind:isEditingLines
					width="w-8"
					compact={true}
					onEnter={doSaveOverrideLines}
				/>
			{/if}
			{#if market.is_manual}
				<OverridePrice
					bind:value={price}
					{selection}
					bind:isEditingPrices={isEditingManualPrices}
					width="w-12"
					compact={true}
					tabindex={tabIndexValue}
					isManual={market.is_manual}
					onEnter={doSaveOverridePrices}
				/>
			{:else}
				<OverridePrice
					bind:value={price}
					{selection}
					bind:isEditingPrices
					width="w-12"
					compact={true}
					tabindex={tabIndexValue}
					onEnter={doSaveOverridePrices}
				/>
			{/if}
		{:else}
			{price}
		{/if}
	</div>
</td>
<td
	class="text-right {getSelectionStatusClass(selection.id)} text-xs"
	class:bg-orange-200={market.is_manual}
	title={getMarketLabel()}>{formatLiability(liability)}</td
>
<td
	class="text-center border-r border-black {getSelectionStatusClass(selection.id)} text-xs"
	class:bg-orange-200={market.is_manual}
	title={getMarketLabel()}>{selection?.bet_count || '-'}</td
>
